export const GET_HELP_CONTENT_STARTED = 'GET_HELP_CONTENT_STARTED';
export const GET_HELP_CONTENT_SUCCESS = 'GET_HELP_CONTENT_SUCCESS';
export const GET_HELP_CONTENT_FAILURE = 'GET_HELP_CONTENT_FAILURE';

export const GET_ALL_CONTENTS_FOR_EXPORT_STARTED = 'GET_ALL_CONTENTS_FOR_EXPORT_STARTED';
export const GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS = 'GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS';
export const GET_ALL_CONTENTS_FOR_EXPORT_FAILURE = 'GET_ALL_CONTENTS_FOR_EXPORT_FAILURE';

export const SEND_CONTENTS_FOR_IMPORT_STARTED = 'SEND_CONTENTS_FOR_IMPORT_STARTED';
export const SEND_CONTENTS_FOR_IMPORT_SUCCESS = 'SEND_CONTENTS_FOR_IMPORT_SUCCESS';
export const SEND_CONTENTS_FOR_IMPORT_FAILURE = 'SEND_CONTENTS_FOR_IMPORT_FAILURE';

export const GET_MAIN_PAGE_BUTTONS_STARTED = 'GET_MAIN_PAGE_BUTTONS_STARTED';
export const GET_MAIN_PAGE_BUTTONS_SUCCESS = 'GET_MAIN_PAGE_BUTTONS_SUCCESS';
export const GET_MAIN_PAGE_BUTTONS_FAILURE = 'GET_MAIN_PAGE_BUTTONS_FAILURE';

export const UPDATE_HELP_CONTENT_STARTED = 'UPDATE_HELP_CONTENT_STARTED';
export const UPDATE_HELP_CONTENT_SUCCESS = 'UPDATE_HELP_CONTENT_SUCCESS';
export const UPDATE_HELP_CONTENT_FAILURE = 'UPDATE_HELP_CONTENT_FAILURE';

export const CREATE_HELP_CONTENT_STARTED = 'CREATE_HELP_CONTENT_STARTED';
export const CREATE_HELP_CONTENT_SUCCESS = 'CREATE_HELP_CONTENT_SUCCESS';
export const CREATE_HELP_CONTENT_FAILURE = 'CREATE_HELP_CONTENT_FAILURE';

export const DELETE_HELP_CONTENT_STARTED = 'DELETE_HELP_CONTENT_STARTED';
export const DELETE_HELP_CONTENT_SUCCESS = 'DELETE_HELP_CONTENT_SUCCESS';
export const DELETE_HELP_CONTENT_FAILURE = 'DELETE_HELP_CONTENT_FAILURE';

export const CLEAR_HELP_CONTENT = 'CLEAR_HELP_CONTENT';

export const RESET_CONTENTS_FOR_EXPORT = 'RESET_CONTENTS_FOR_EXPORT';

